module.exports = __webpack_public_path__ + "static/media/slide-image-1-large-min-2.9f3f04ae.jpeg";